const clientManagementPrefix = 'clientManagement_';

export const events = {
	dismissSuggestedContact: `${clientManagementPrefix}dismissSuggestedContact`,
	addedSuggestedContact: `${clientManagementPrefix}addedSuggestedContact`,
	dismissSuggestedClient: `${clientManagementPrefix}dismissSuggestedClient`,
	addedSuggestedClient: `${clientManagementPrefix}addedSuggestedClient`,
	legacyTokenDetected: `${clientManagementPrefix}LegacyTokenDetected`,
	redirectToManageUser: `${clientManagementPrefix}RedirectToManageUser`,
	clientListFilterSelected: `${clientManagementPrefix}ClientListFilterSelected`,
	createClient: `${clientManagementPrefix}createClient`,
	addServiceContact: `${clientManagementPrefix}addServiceContact`,
	addClientContact: `${clientManagementPrefix}addClientContact`,
	makePrimaryClientContact: `${clientManagementPrefix}makePrimaryClientContact`,
	makePrimaryServiceContact: `${clientManagementPrefix}makePrimaryServiceContact`,
	addCustomField: `${clientManagementPrefix}addedCustomField`,
	deleteClient: `${clientManagementPrefix}deletedClient`,
	linkFilesAndFolders: `${clientManagementPrefix}linkedFilesAndFolders`,
};

export const analyticsIds = {
	addSingleSuggestedContact: `${clientManagementPrefix}AddSingleSuggestedContact`,
	setClientContactAsPrimary: `${clientManagementPrefix}SetClientContactAsPrimary`,
	deleteClientsFromContextBar: `${clientManagementPrefix}DeleteClientsFromContextBar`,
	deleteSingleClientFromActions: `${clientManagementPrefix}DeleteSingleClientFromActions`,
	removeClientContactPrimaryDesignation: `${clientManagementPrefix}RemoveClientContactPrimaryDesignation`,
	removeClientContact: `${clientManagementPrefix}RemoveClientContact`,
	removeTeamMember: `${clientManagementPrefix}RemoveTeamMember`,
	setTeamMemberAsPrimary: `${clientManagementPrefix}SetTeamMemberAsPrimary`,
	removeTeamMemberPrimaryDesignation: `${clientManagementPrefix}RemoveTeamMemberPrimaryDesignation`,
	legacyTokenReauth: `${clientManagementPrefix}LegacyTokenReauth`,
	showMyClientsCheckbox: `${clientManagementPrefix}ShowMyClientsOnlyCheckbox`,
	restoreClient: `${clientManagementPrefix}RestoreClient`,
	navigateFromFolderToClient: `${clientManagementPrefix}NavigateFromFolderToClient`,
	clientsConfiguration: `${clientManagementPrefix}ClientsConfiguration`,
	recentlyDeleted: `${clientManagementPrefix}RecentlyDeleted`,
	clientHubAccessManagement: `${clientManagementPrefix}clientHubAccessManagement`,
	serviceTeamsManagement: `${clientManagementPrefix}serviceTeamsManagement`,
	removeCustomField: `${clientManagementPrefix}RemoveCustomField`,
	showClientCustomFieldCreateDrawer: `${clientManagementPrefix}ShowClientCustomFieldCreateDrawer`,
	showContactCustomFieldCreateDrawer: `${clientManagementPrefix}ShowContactCustomFieldCreateDrawer`,
	createClientCustomField: `${clientManagementPrefix}createClientCustomField`,
	createContactCustomField: `${clientManagementPrefix}createContactCustomField`,
	enableTrialModeSwitch: `${clientManagementPrefix}enableTrialModeSwitch`,
	openCreateClientDrawerFromList: `${clientManagementPrefix}openCreateClientDrawerFromList`,
	submitCreateClient: `${clientManagementPrefix}submitCreateClient`,
	cancelCreateClient: `${clientManagementPrefix}cancelCreateClient`,
	navigateToClientHubSettings: `${clientManagementPrefix}navigateToClientHubSettings`,
	saveEditColumns: `${clientManagementPrefix}saveEditColumns`,
	cancelEditColumns: `${clientManagementPrefix}cancelEditColumns`,
};

export const suggestedContactAnalyticsIds = {
	primaryServiceTeamMemberOption: 'suggested-primary-service-team-member-option',
	serviceTeamMemberOption: 'suggested-service-team-member-option',
	primaryClientContactPrincipalOption:
		'suggested-primary-client-contact-principal-option',
	clientContactPrincipalOption: 'suggested-client-contact-principal-option',
	primaryServiceTeamPrincipalOption: 'suggested-primary-service-team-principal-option',
	serviceTeamPrincipalOption: 'suggested-service-team-principal-option',
};

interface Window {
	pendo?: any;
}

export function sendPendoTrackEvent(event: string, metadata: any = {}) {
	try {
		const pendo = (window as unknown as Window).pendo;
		if (!pendo?.track) {
			return;
		}
		const metadataWithProductName = {
			...metadata,
			product: 'ShareFile - Client Management',
			type: event,
		};
		pendo.track(event, metadataWithProductName);
	} catch {}
}
